<script setup>
const filter = ref(null);

defineExpose({
  height: computed(() => {
    return filter.value?.clientHeight;
  }),
  top: computed(() => {
    return filter.value?.offsetTop;
  }),
});
</script>

<template>
  <section
    ref="filter"
    class="border-b-2 border-b-slate-200 bg-white p-5 dark:rounded-b-3xl dark:border-transparent dark:bg-primary-blue-light xl:top-[80px] xl:z-30"
  >
    <slot name="leftSideBlock" />

    <div class="flex-wrapper flex w-full flex-wrap items-center gap-x-2 gap-y-4">
      <!-- SEARCH -->
      <slot name="mainBlock" />

      <!-- CHOOSE CATEGORY -->
      <slot name="secondary" />

      <!-- CHOOSE SORT -->
      <slot name="third" />
    </div>
    <slot name="rightSideBlock" />
    <slot name="bottomBlock" />
  </section>
</template>

<style scoped lang="scss">
#sort,
#category,
#search {
  @apply text-lg rounded-lg border-2 border-blue-400 bg-white dark:bg-white/20 dark:text-white;
}
</style>
